// Enums
import { Motivation } from '@app/enums/motivation';

// Models
import { EntityModel } from './entity.model';
import { ActorModel } from './actor.model';
import { MediaReferenceMetadataModel } from './media-reference-metadata.model';
import { ArticleReferenceModel } from './article-reference.model';
import type { SourceReferenceModel } from './source-reference.model';
import { IncidentStatus } from '@app/enums/incident-status';
import { TechnicalStepModel } from './technical-step.model';

export type IncidentModel = {
  id: number;
  version: string;
  title: string;
  summary: string;
  entityId: number | null;
  entity: EntityModel | null;
  actorId: number | null;
  actor: ActorModel | null;
  motivation: keyof typeof Motivation;
  mediaReferences: MediaReferenceMetadataModel[];
  articleReferences: ArticleReferenceModel[];
  sourceReferences: SourceReferenceModel[];
  incidentDuplicateIds: number[];
  isDuplicateIncident: boolean;
  masterIncidentId: number | null;
  isMasterIncident: boolean;
  status: IncidentStatus;
  isReviewed: boolean;
  isLocked: boolean;
  lockedDateTime?: string;
  startedAt: string | null;
  endedAt?: string | null;
  createdAt: string | null;
  technicalSteps?: TechnicalStepModel[];
  fieldReferences?: FieldReferenceModel[];
};

export type IncidentBaseModel = {
  id: number;
  title: string;
  entity: string | null;
  incidentDate: string;
  status: IncidentStatus;
  isReviewed: boolean;
  isMasterIncident: boolean;
  masterIncidentId: number | null;
};

export type FieldReferenceModel = {
  name: string;
  type: FieldReferenceType;
  sourceId: number;
  state: FieldReferenceState;
};

export type FieldReferenceType = 'Unknown' | 'Incident' | 'TechnicalStep' | 'ArticleReference' | 'MediaReference';
export type FieldReferenceState = 'Unknown' | 'Manual' | 'Sourced' | 'Removed';

export enum IncidentSortBy {
  Title = 0,
  EntityName = 1,
  StartedAt = 2,
  IsReviewed = 3,
}
